exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tag-item-portfolio{margin-bottom:40px}.pagination-portfolio{margin-top:70px;margin-left:250px;margin-bottom:70px}.teaser-item-portfolio{margin-bottom:38px}.blog-side-bar-right{position:absolute;right:0;top:0}.page-contacts-paragraph{border-radius:5px;background:#ececec;padding:11px 20px 5px;margin-bottom:60px}.contacts-h{text-transform:uppercase;font-size:20px;margin-bottom:60px}.address-content{position:absolute;left:900px;font-size:20px}.form-h{display:block;text-transform:uppercase;font-size:20px;margin-bottom:60px}.naiming-top-bar{margin-left:0;margin-top:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-984f22c6","scoped":false,"hasInlineConfig":true}!./src/styles/common.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-984f22c6","scoped":false,"hasInlineConfig":true}!./src/styles/common.css
// module chunks = index